// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"3262d23e","982":"ea503873"}[chunkId] + ".chunk.js";
};